export default __webpack_public_path__ + "static/media/10_PM_Vor den Wahlen und nach den Wahlen.92b127d7.pdf";